export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11323.bf78f4fb.jpg";